(() => {
  const initialize = () => {
    const footer = document.querySelector('[data-retailer-footer]');
    if (!footer || footer.dataset.initialized === 'true') return;
    footer.dataset.initialized = 'true';
    const triggers = new WeakMap();
    const skipRestore = new WeakSet();
    const close = (dialog, restore = true) => {
      if (!dialog?.open) return;
      if (!restore) skipRestore.add(dialog);
      dialog.close();
    };
    const scrollTo = target => {
      if (!target) return;
      // Clearance variant cards: scroll and focus the visible choices.
      if (target.matches('[data-retailer-variant]') || target.id === 'retailer-buy') {
        target = document.querySelector('[data-retailer-product] [data-retailer-variant-cards]')
          || document.querySelector('[data-retailer-product] [data-retailer-variant-choice]:checked');
        if (!target) return;
      }
      if (target.matches('details')) target.open = true;
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      const cards = target.matches('[data-retailer-variant-cards]') ? target : target.querySelector('[data-retailer-variant-cards]');
      const selectedChoice = cards?.querySelector('[data-retailer-variant-choice]:checked:not(:disabled)')
        || cards?.querySelector('[data-retailer-variant-choice]:not(:disabled)');
      const focus = selectedChoice || (target.matches('input:not([hidden]),summary,button,select:not([hidden]):not([data-retailer-variant])')
        ? target : target.querySelector('summary,h2,h3,select:not([hidden]):not([data-retailer-variant])'));
      if (focus) {
        if (/^H[1-6]$/.test(focus.tagName)) focus.setAttribute('tabindex','-1');
        focus.focus({preventScroll:true});
      }
    };
    footer.querySelectorAll('[data-footer-dialog]').forEach(dialog => {
      dialog.addEventListener('close', () => {
        if (skipRestore.has(dialog)) { skipRestore.delete(dialog); return; }
        triggers.get(dialog)?.focus({preventScroll:true});
      });
      let backdropStart = false;
      const outside = event => {
        const rect = dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      };
      dialog.addEventListener('pointerdown', event => { backdropStart = event.target === dialog && outside(event); });
      dialog.addEventListener('click', event => { if (backdropStart && event.target === dialog && outside(event)) close(dialog); backdropStart = false; });
    });
    footer.addEventListener('click', event => {
      const trigger = event.target.closest('[data-footer-dialog-open]');
      if (trigger) {
        const dialog = document.getElementById(trigger.dataset.footerDialogOpen);
        if (!dialog?.matches('[data-footer-dialog]') || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        footer.querySelectorAll('[data-footer-dialog][open]').forEach(current => close(current, false));
        triggers.set(dialog, trigger);
        dialog.showModal();
        dialog.querySelector('[data-footer-dialog-close]')?.focus({preventScroll:true});
        return;
      }
      const closeButton = event.target.closest('[data-footer-dialog-close]');
      if (closeButton) { close(closeButton.closest('dialog')); return; }
      const variant = event.target.closest('[data-footer-variant]');
      if (variant) {
        const select = document.querySelector('[data-retailer-variant]');
        if (!select || select.disabled) { event.preventDefault(); return; }
        const option = Array.from(select.options).find(item => item.value === variant.dataset.footerVariant && !item.disabled);
        if (!option) return;
        event.preventDefault();
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles:true}));
        scrollTo(document.querySelector('[data-retailer-product] [data-retailer-variant-cards]')
          || document.querySelector('[data-retailer-product] [data-retailer-variant-choice]:checked'));
        return;
      }
      const productPanel = event.target.closest('[data-footer-product-panel]');
      if (productPanel) {
        const name = productPanel.dataset.footerProductPanel;
        const panel = Array.from(document.querySelectorAll('[data-retailer-panel]')).find(item => item.dataset.retailerPanel === name);
        if (!panel) return;
        event.preventDefault();
        scrollTo(panel);
        return;
      }
      const anchor = event.target.closest('a[href^="#"]');
      const dialog = anchor?.closest('[data-footer-dialog]');
      if (dialog) {
        const target = document.getElementById(anchor.getAttribute('href').slice(1));
        if (target) { event.preventDefault(); close(dialog, false); requestAnimationFrame(() => scrollTo(target)); }
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
